import { useEffect, useState } from "react"

const useHTMLElementSize = <T extends HTMLElement>(element: T | null | undefined) => {
  const [width, setWidth] = useState(0)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (!entry) return

      setWidth(entry.contentRect.width)
      setHeight(entry.contentRect.height)
    })

    if (element) observer.observe(element)

    return () => {
      element && observer.unobserve(element)
    }
  }, [element])

  return { width, height }
}

export default useHTMLElementSize
